<template>
   <a-modal
      title="登录"
      :visible="showvisible"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="登录"
    >

    <a-form-model ref="form" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="账号">
       <a-input v-model="form.phone" placeholder="手机号" />
      </a-form-model-item>
      <a-form-model-item label="密码">
       <a-input type="password" v-model="form.mima" />
      </a-form-model-item>
      <a-form-model-item label="验证码">
       <a-input v-model="form.yanzhengma" class="yzmput" />
       <img @click="renderVerifyCodeImg" :src="yzIMG" alt="" class="yzm">
      </a-form-model-item>
    </a-form-model>

    </a-modal>
</template>

<script>
import {encryptedData} from '../../../../../common/utils/Encryption/JSEncrypt'
export default {
  props:{
    visible:{
      type:Boolean,
      require:true
    },
    willpush:{
      type:String,
      default:''
    }
  },
  data(){
    return{
       //存放验证码图片的路径
      yzIMG:'',
       //存放验证码的路径
      yzmData:'',

      labelCol: { span: 6 },
      wrapperCol: { span: 14 },

      showvisible:false,

      form:{
        phone:'',
        mima:'',
        yanzhengma:''
      }
    }
  },

  mounted(){
    this.showvisible=this.visible
  },

  watch:{
    visible(){
      this.showvisible=this.visible
    }
  },

  created(){
    this.renderVerifyCodeImg()
  },

  methods:{
    //点击了登录
    handleOk(){
        if(this.form.phone==''){
        return this.$message.warning('请输入账号或手机号')
      }else if(this.form.mima==''){
        return this.$message.warning('请输入密码')
      }

      this.post({
        url:'checkCaptcha',
        data:{
          inputCode:this.form.yanzhengma,
          codeKey:this.yzmData
        }
      },(res)=>{
          console.log(res);
        if(res.code===200){
          console.log(5000);
          this.post({
          url: 'login',
          data:{
            userName:this.form.phone,
            passWord:encryptedData(this.form.mima),
            logonType:'1'
          }
        }, (res) => {

            if(res.code!==200) return this.$message.warning(res.message)

            if(res.code===200){
              console.log(res);
              sessionStorage.setItem('BDSOFT-TOKEN',res.data.token)
              sessionStorage.setItem('a0d',res.data.user.id)

              clearTimeout(timer)
              var timer = setTimeout( function(){
                sessionStorage.removeItem('BDSOFT-TOKEN')
                sessionStorage.removeItem('aabb')
                sessionStorage.removeItem('a0d')
                sessionStorage.removeItem('named')
              }, 1800000);

              this.myResume()

              this.handleCancel()
              this.$router.push(this.willpush)
            }
           })

        }else{
          this.renderVerifyCodeImg()
          return this.$message.warning('验证码输入错误')
        }
      })


    },
    //关闭弹窗
    handleCancel(){
      this.showvisible=false
      this.form={
        phone:'',
        mima:'',
        yanzhengma:''
      }
      this.$refs.form.resetFields()
      this.$emit('update:visible',false)
    },

    //获取验证码信息
    renderVerifyCodeImg(){
       this.post({
        url:'renderVerifyCodeImg',
      },(res)=>{
        this.yzIMG=res.data.base64Img
        this.yzmData=res.data.captchaKey
        console.log(res);
      })
    },

     //获取简历人员信息
    myResume(){
      this.post({
        url:'myResume'
      },(res)=>{
        sessionStorage.setItem('aabb',res.data.a00)
      })
    },

  }
}
</script>


<style scoped>
.yzmput{
  width: 178px!important;
}
.yzm{
  display: inline-block;
    font-size: 14px;
    cursor: pointer;
    width: 75px;
    height: 30px;
    border: 1px solid black;
    margin-left: 20px;
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/sy/compos/login.vue